var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_10036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.093 7.6084C28.3061 4.70918 25.2908 1.69453 22.3916 0.907031C20.6139 0.464062 18.2326 0.00761719 15 0C11.7674 0.00820312 9.38613 0.464062 7.6084 0.907617C4.70977 1.69453 1.69453 4.70918 0.907031 7.6084C0.464062 9.38613 0.00761719 11.7674 0 15C0.00820312 18.2326 0.464062 20.6139 0.907617 22.3916C1.69512 25.2908 4.70977 28.3055 7.60898 29.093C9.38672 29.5365 11.768 29.9924 15.0006 30.0006C18.2326 29.9924 20.6145 29.5365 22.3922 29.093C25.2914 28.3055 28.3061 25.2908 29.0936 22.3916C29.5371 20.6145 29.993 18.2326 30.0012 15C29.993 11.7674 29.5371 9.38613 29.0936 7.6084H29.093Z",
    fill: "#FFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0553 21.4574C25.4377 20.4273 23.0723 19.3557 20.7982 19.0762C19.4037 18.9186 17.5357 18.7562 14.9998 18.7539C12.4639 18.7568 10.5953 18.9186 9.20137 19.0762C6.92734 19.3562 4.56191 20.4273 3.94434 21.4574C3.59629 22.0891 3.23887 22.9352 3.23242 24.0842C3.23887 25.2326 3.59629 26.0793 3.94434 26.7109C4.56191 27.741 6.92734 28.8127 9.20137 29.0922C10.5959 29.2498 12.4645 29.4121 14.9998 29.4145C17.5357 29.4115 19.4037 29.2492 20.7982 29.0922C23.0729 28.8127 25.4377 27.741 26.0553 26.7109C26.4027 26.0793 26.7607 25.2332 26.7672 24.0842C26.7607 22.9357 26.4027 22.0891 26.0553 21.4574Z",
    fill: "url(#paint0_radial_615_10036)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.44922C8.6182 3.44922 3.44922 8.6182 3.44922 15C3.44922 21.3818 8.6182 26.5508 15 26.5508C21.3818 26.5508 26.5508 21.3818 26.5508 15C26.5508 8.6182 21.3818 3.44922 15 3.44922ZM15 25.107C9.42676 25.107 4.89307 20.5733 4.89307 15C4.89307 9.42676 9.42676 4.89307 15 4.89307C20.5733 4.89307 25.107 9.42676 25.107 15C25.107 20.5733 20.5733 25.107 15 25.107Z",
    fill: "#C73636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 24.2725C20.2723 24.2725 24.546 19.9989 24.546 14.7271C24.546 9.45529 20.2723 5.18164 15.0005 5.18164C9.72872 5.18164 5.45508 9.45529 5.45508 14.7271C5.45508 19.9989 9.72872 24.2725 15.0005 24.2725Z",
    fill: "#C73636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2734 12.2725L15.3416 15.3406L18.4098 18.4088M18.4098 12.2725L12.2734 18.4088",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_615_10036",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9998 24.6794) scale(11.7674 5.29532)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C73636",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C73636",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_10036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.37e28d5f069dc8de7dc5f12f9614856f.svg";
export { ForwardRef as ReactComponent };